const searchTriggers = document.querySelectorAll('[data-search-trigger]');
const searchDrawer = document.querySelector('[data-search-drawer]');
const form = searchDrawer.querySelector('form');
const searchError = document.querySelector('[data-search-error]');
const defaultSearch = searchDrawer.querySelector('.default-search');
const searchInput = searchDrawer.querySelector('input[type="search"]');
const searchResults = document.querySelector('#predictive-search');
const trendingSearch = searchDrawer.querySelectorAll('.trending-search ul li');
const clearBtn = form.querySelector('.search__clear');

searchTriggers.forEach(trigger => {
    trigger.addEventListener('click', (ev) => {
        ev.preventDefault();
        searchDrawer.classList.toggle('show');
        document.addEventListener('keyup', (e) => {
            if (e.keyCode === 27) {
                searchDrawer.classList.remove('show');
            }
        });
    
        searchInput.addEventListener('keyup', (e) => {
            if (e.keyCode === 13) {
                e.preventDefault();
            }
        });
        
        function predictiveSearch(e) {
            setTimeout(() => {
                const searchTerm = searchInput.value.trim();
                
                if (searchTerm.length > 0) {
                    defaultSearch.style.display = 'none';
                    searchResults.style.display = 'block';
                    clearBtn.style.display = 'block';
                } else {
                    defaultSearch.style.display = 'flex';
                    searchResults.style.display = 'none';
                    searchResults.innerHTML = '';
                    clearBtn.style.display = 'none';
                }
        
                fetch(`/search/suggest.json?q=${searchTerm}&resources[type]=product&resources[options][fields]=title,body,variants.title`)
                .then((response) => {
                  if (!response.ok) {
                    var error = new Error(response.status);
                    throw error;
                  }
                  return response.json();
                })
                .then((suggestions ) => {
                    searchResults.innerHTML = '';
                    const productSuggestions = suggestions.resources.results.products;
                    
                    if(productSuggestions.length === 0) {
                        searchError.style.display = 'block';
                        defaultSearch.style.display = 'flex';
                        searchResults.style.display = 'none';
                        searchError.classList.add('search-heading');
                        searchError.innerHTML = `Your search for “${searchTerm}” didn’t return any results.`;
                    } else{
                        searchError.style.display = 'none';
                        const p = document.createElement('p');
                        p.classList.add('search-result');
                        p.classList.add('search-heading');
                        p.innerHTML = `${productSuggestions.length} results`;
                        searchResults.appendChild(p);
        
                        const grid = document.createElement('div');
                        grid.classList.add('search-grid');
                        searchResults.appendChild(grid);
                        productSuggestions.forEach(product => {
                            // console.log(productSuggestions);
                            // console.log(product.body);
                            // console.log(product.body.innerHTML);
        
                            grid.innerHTML += `
                            <li class="search-product-card">
                                <a href="${product.url}">
                                    <div class="product__image">
                                        <img src="${product.image}" alt="${product.title}">
                                    </div>
                                    <div class="product__info">
                                        <div class="product__info-title">${product.title}</div>
                                        <div class="product__info-price">£${product.price}</div>
                                    </div>
                                </a>
                            </li>
                            `;
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                  throw error;
                }); 
            }, 300);
        }
    
        searchInput.addEventListener('input', (e) => {
            predictiveSearch(e);
        });
    
        trendingSearch.forEach(trending => {
            trending.addEventListener('click', (e) => {
                const trendingContent = trending.innerHTML;
                searchInput.value = trendingContent;
                predictiveSearch(e);
            })
        });

        clearBtn.addEventListener('click', (e) => {
            e.preventDefault();
            searchInput.value = '';
            predictiveSearch(e);
        });
    });
});
